import type { HttpValidationError } from '../api/intranet'
import type { NotificationCallOptions } from './useNotifications'

import { getErrorMessage } from './getErrorMessage'

export const showErrorNotifications = (
  error: HttpValidationError,
  errorNotification: (message: string, options?: NotificationCallOptions) => void | Promise<void>,
  fallbackMessage?: string,
) => {
  const errorMessage = getErrorMessage({ error, fallbackMessage })

  if (Array.isArray(errorMessage)) {
    errorMessage.forEach((messageItem) => {
      errorNotification(messageItem)
    })
  } else {
    errorNotification(errorMessage)
  }
}
